import { getConversationById } from '@app/helpers'
import { ConversationItem } from '@app/models'

import { ChatState } from '../types'

export const onFetchMessagesStart = (
  state: ChatState,
  id: number
): ChatState => {
  const conversation = getConversationById(state.conversations, id)
  if (!conversation) {
    return state
  }

  const conversations: Record<number, ConversationItem> = {
    ...state.conversations,
    [id]: { ...conversation, fetching: 'PENDING' },
  }

  return {
    ...state,
    conversations,
  }
}
